import { render, staticRenderFns } from "./ProgressBarSteps.vue?vue&type=template&id=704fcf87&scoped=true"
import script from "./ProgressBarSteps.vue?vue&type=script&lang=js"
export * from "./ProgressBarSteps.vue?vue&type=script&lang=js"
import style0 from "./ProgressBarSteps.vue?vue&type=style&index=0&id=704fcf87&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "704fcf87",
  null
  
)

export default component.exports